module.exports = __webpack_public_path__ + "static/media/documentation.f4830572.md";